const highlights = [
  {
    title: 'Emergency Service',
    text: 'Urgent gearbox, hydraulic, and mechanical repair needs are prioritized when equipment is down.',
    icon: '/icons/technician.svg',
  },
  {
    title: 'Free Pickup/Shipping',
    text: 'Pickup and shipping support is available to help move repair work forward across Canada.',
    icon: '/icons/customer-focused.svg',
  },
  {
    title: 'Quick Turnaround Time',
    text: 'Repair timing depends on scope and parts, but the process is built to move quickly.',
    icon: '/icons/quality-assured.svg',
  },
];

function ServiceHighlights() {
  return (
    <section className="service-highlights" aria-label="Repair service highlights">
      <div className="container service-highlights__grid">
        {highlights.map((item) => (
          <article key={item.title} className="service-highlights__item">
            <img src={`${process.env.PUBLIC_URL}${item.icon}`} alt="" aria-hidden="true" />
            <div>
              <h2>{item.title}</h2>
              <p>{item.text}</p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}

export default ServiceHighlights;
